import { useCallback, useEffect, useRef, useState } from 'react';
import { ModalsModule } from '@wix/domains-search-suite';
const upgradePaywall = ModalsModule.internals.domainsActionsModalsController.upgradePaywall;
export const useUpgradePaywall = _ref => {
  let layout = _ref.layout,
    domainName = _ref.domainName,
    siteName = _ref.siteName,
    onUpgrade = _ref.onUpgrade;
  const _useState = useState(false),
    isPrimaryButtonLoading = _useState[0],
    setIsPrimaryButtonLoading = _useState[1];

  // Keep the latest callback without re-showing the modal on every render.
  const onUpgradeRef = useRef(onUpgrade);
  onUpgradeRef.current = onUpgrade;
  const handleUpgrade = useCallback(async () => {
    setIsPrimaryButtonLoading(true);
    try {
      // On success the browser navigates away, so loading stays until unload.
      await (onUpgradeRef.current == null ? void 0 : onUpgradeRef.current());
    } catch {
      setIsPrimaryButtonLoading(false);
    }
  }, []);
  useEffect(() => {
    upgradePaywall.show({
      layout,
      domainName,
      siteName,
      isPrimaryButtonLoading,
      primaryButtonOnClick: handleUpgrade
    });
  }, [layout, domainName, siteName, isPrimaryButtonLoading, handleUpgrade]);
  useEffect(() => () => upgradePaywall.hide(), []);
};
//# sourceMappingURL=useUpgradePaywall.js.map